import React, { memo, useCallback } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import styles from '../styles/navbar.module.css';
import companyLogo from '../../assets/images/logo.webp';
import { FaBars, FaTimes } from 'react-icons/fa';
import MenuItem from './MenuItem';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const toggleMenu = useCallback(() => {
    setMenuOpen(prev => !prev);
  }, []);

  // const toggleToJapanese = useCallback(() => {
  //   localStorage.setItem('language', 'jp');
  //   const newPath = location.pathname.replace('/en', '/jp');
  //   navigate(newPath);
  // }, [navigate, location]);

  const toggleToJapanese = useCallback(() => {
  localStorage.setItem('language', 'jp');
  navigate('/jp');
}, [navigate]);

  const servicesDropdownItems = React.useMemo(() => [
    { path: "/en/managed-services", label: "Managed Services" },
    { path: "/en/co-managed-it-services", label: "Co-Managed IT Services" },
    { path: "/en/infrastructuremanagement", label: "Infrastructure Management" },
    { path: "/en/networkmonitoring", label: "Network Monitoring" },
    { path: "/en/vapt-assessment", label: "VAPT Assessment" },
    { path: "/en/application-development", label: "Application Development" },
    { path: "/en/erp-solutions", label: "ERP Solutions" },
  ], []);

  const aboutUsDropdownItems = React.useMemo(() => [
    { path: "/en/about", label: "About" },
    { path: "/en/life-at-dg", label: "Life@DG FutureTech" },
    { path: "/en/media", label: "Media" },
  ], []);

  const successStoriesDropdownItems = React.useMemo(() => [
    { path: "/en/success-story-finTech", label: "Fintech Solutions for Digital Finance" },
    { path: "/en/success-story-retailBanking", label: "Retail Banking " },
    { path: "/en/success-story-digitalPayment", label: "Digital Payment Service Provider" },
    { path: "/en/success-story-loanEnquiry", label: "Smart Car Loan Platform" },
    { path: "/en/success-story-webapp", label: "Web Application Framework Migration" },
    { path: "/en/success-story-erp-solutions", label: "ERP Modules Implementation" },
  ], []);

  const menuItems = React.useMemo(() => [
    { path: '/en/about', label: 'About Us', hasDropdown: true, dropdownItems: aboutUsDropdownItems },
    { path: '/en/managed-services', label: 'Services', hasDropdown: true, dropdownItems: servicesDropdownItems },
    { path: '/en/serviceplans', label: 'Service Plans' },
    { path: '/en/success-story-finTech', label: 'Success Stories', hasDropdown: true, dropdownItems: successStoriesDropdownItems },
    { path: '/en/career', label: 'Careers' },
    { path: '/en/contact', label: 'Contact' },
    { path: '/en/SecurityAssessment', label: 'Security Assessment' },
  ], [servicesDropdownItems, successStoriesDropdownItems, aboutUsDropdownItems]);

  return (
    <nav className={styles.navbar} role="navigation">
      <div className={styles.navbarContainer}>
        <div className={styles.navbarLogo}>
          <NavLink to="/en">
            <img
              src={companyLogo}
              alt="DG FutureTech Logo"
              className={styles.logo}
              width="120"
              height="40"
              loading="eager"
              fetchPriority="high"
            />
          </NavLink>
        </div>

        <div className={styles.emptySpace}></div>

        <div className={styles.navLinksContainer}>
          <div className={`${styles.navbarMenu} ${menuOpen ? styles.navbarMenuOpen : ''}`}>
            {menuItems.map((item, index) => (
              <MenuItem
                key={item.path}
                {...item}
                isLast={index === menuItems.length - 1}
                toggleMenu={toggleMenu}
                isMenuOpen={menuOpen}
              />
            ))}

            {/* Mobile-only consultation button */}
            <button
              onClick={toggleToJapanese}
              style={{
                border: "2px solid #007BFF",
                borderRadius: "5px",
                padding: "8px 16px",
                fontSize: "1rem",
                cursor: "pointer",
                fontWeight: "500"
              }}
            >
              日本語
            </button>

          </div>

          <button
            className={styles.hamburger}
            onClick={toggleMenu}
            aria-expanded={menuOpen}
            aria-label="Toggle navigation menu"
            type="button"
          >
            {!menuOpen ? <FaBars aria-hidden="true" /> : <FaTimes aria-hidden="true" />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default memo(Navbar);